<small class="debug"> {{ me }} </small>
@if (lockMode) {
    <div class="lock-container">
        <div class="lock-icon-wrapper">
            <mat-icon class="lock-icon">verified_user</mat-icon>
        </div>
        <h3 class="lock-title">{{ 'general.authenticator' | transloco }}</h3>
        <p class="lock-subtitle">{{ 'general.enterAuth' | transloco }}</p>
        <div class="code-input-row">
            @for (control of inputControls; track $index; let i = $index) {
                <input
                    matInput
                    maxlength="1"
                    type="text"
                    inputrestriction="numbers"
                    pattern="[0-9]*"
                    (input)="onInput($event, i)"
                    (keydown.backspace)="onBackspace($event, i)"
                    #inputBox
                    class="code-input"
                    [(ngModel)]="inputValues[i]">
            }
            <button mat-icon-button class="clear-code-btn" (click)="clearInputs()">
                <mat-icon>backspace</mat-icon>
            </button>
        </div>
        <button mat-raised-button
                color="warn"
                class="auth-submit-btn"
                [disabled]="!inputValuesReady"
                (click)="checkTwoFactor()">
            <mat-icon>lock_open</mat-icon>
            {{ 'general.authenticator' | transloco }}
        </button>
    </div>
  } @else {
    <div class="twofa-toggle-container">
      <div class="twofa-status-row">
        <div class="twofa-status-indicator" [class.enabled]="m_twoFactorState">
          <mat-icon>{{ m_twoFactorState ? 'verified_user' : 'shield' }}</mat-icon>
        </div>
        <div class="twofa-status-text">
          <span class="twofa-label">{{ 'account.twoFactoAuth' | transloco }}</span>
          <span class="twofa-state" [class.enabled]="m_twoFactorState">
            {{ m_twoFactorState ? ('ai.enabled' | transloco) : ('ai.disabled' | transloco) }}
          </span>
        </div>
        <button mat-raised-button
                [color]="m_twoFactorState ? 'primary' : 'warn'"
                class="twofa-action-btn"
                (click)="onTwoFactorAuthentication()">
          <mat-icon>{{ m_twoFactorState ? 'lock_open' : 'lock' }}</mat-icon>
          {{ m_twoFactorState ? ('general.remove' | transloco) : ('general.enable' | transloco) }}
        </button>
      </div>
    </div>
  }


    <!-- Disable 2FA Modal -->
    <ng-template let-modal #twoFactorModalEnable>
        <div class="modal-container">
            <div class="modal-icon-wrapper danger">
                <mat-icon class="modal-icon">shield</mat-icon>
            </div>
            <h3 class="modal-title">{{ 'general.disableTwoFactor' | transloco }}</h3>
            <p class="modal-subtitle">{{ 'general.enterAuth' | transloco }}</p>
            <div class="code-input-row">
                @for (control of inputControls; track $index; let i = $index) {
                    <input matInput maxlength="1" type="text"
                        inputrestriction="numbers" pattern="[0-9]*"
                        (input)="onInput($event, i)"
                        (keydown.backspace)="onBackspace($event, i)"
                        #inputBox class="code-input"
                        [(ngModel)]="inputValues[i]">
                }
                <button mat-icon-button class="clear-code-btn" (click)="clearInputs()">
                    <mat-icon>backspace</mat-icon>
                </button>
            </div>
            <div class="modal-actions">
                <button mat-stroked-button (click)="onClose()">
                    {{ 'general.cancel' | transloco }}
                </button>
                <button mat-raised-button color="warn"
                        [disabled]="!inputValuesReady"
                        (click)="disableTwoFactor()">
                    <mat-icon>remove_moderator</mat-icon>
                    {{ 'general.remove' | transloco }}
                </button>
            </div>
        </div>
    </ng-template>

    <!-- Enable 2FA Modal -->
    <ng-template let-modal #twoFactorModalDisable>
        <div class="modal-container">
            <div class="modal-icon-wrapper">
                <mat-icon class="modal-icon">verified_user</mat-icon>
            </div>
            <h3 class="modal-title">{{ 'general.enableAuth' | transloco }}</h3>
            <div class="qr-wrapper">
                <img [src]="twoFactorQrCode" class="qr-image">
            </div>
            <div class="scan-instructions">
                <mat-icon class="instruction-icon">phone_android</mat-icon>
                <span>{{ 'general.enterAuth' | transloco }}</span>
            </div>
            <div class="code-input-row">
                @for (control of inputControls; track $index; let i = $index) {
                    <input matInput maxlength="1" type="text"
                        inputrestriction="numbers" pattern="[0-9]*"
                        (input)="onInput($event, i)"
                        (keydown.backspace)="onBackspace($event, i)"
                        #inputBox class="code-input"
                        [(ngModel)]="inputValues[i]">
                }
                <button mat-icon-button class="clear-code-btn" (click)="clearInputs()">
                    <mat-icon>backspace</mat-icon>
                </button>
            </div>
            <div class="modal-actions">
                <button mat-stroked-button (click)="onClose()">
                    {{ 'general.cancel' | transloco }}
                </button>
                <button mat-raised-button color="warn"
                        [disabled]="!inputValuesReady"
                        (click)="enableTwoFactor()">
                    <mat-icon>verified_user</mat-icon>
                    {{ 'general.enable' | transloco }}
                </button>
            </div>
        </div>
    </ng-template>


